window.showError = function(message) {
    $('#toastRequestError span.error-message').text(message);
    $('#toastRequestError').toast('show');
};

window.showSuccess = function(message) {
    $('#toastSuccess span.success-message').text(message);
    $('#toastSuccess').toast('show');
};